var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "-9.5 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iphone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 4h8.281c1.313 0 2.375 1.063 2.375 2.375v19.25c0 1.313-1.063 2.375-2.375 2.375h-8.281c-1.313 0-2.375-1.063-2.375-2.375v-19.25c0-1.313 1.063-2.375 2.375-2.375zM1.531 23.281h9.969v-14.781h-9.969v14.781zM6.5 26.563c0.75 0 1.313-0.563 1.313-1.281 0-0.75-0.563-1.313-1.313-1.313-0.719 0-1.281 0.563-1.281 1.313 0 0.719 0.563 1.281 1.281 1.281z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.ec6b1dfdb051526bc8680fe7005efb60.svg";
export { ForwardRef as ReactComponent };